import Vue from 'vue'
import { store } from '@/store/store'

Vue.filter('capitalize', (value) => {
	if (!value) return ''
	value = value.toString()
	return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('currencyConversion', (value) => {
	const countryData = JSON.parse(JSON.stringify(store.getters['siteData/getSelectedCountry']))
	if (!value) return '0.0'
	const priceValue = parseFloat(value) * parseFloat(countryData.conversion_value)
	return `${countryData.currency_symbol} ${priceValue.toFixed(2)}`
})
